import { ProcedureType } from "./search/utils/constants";

/**
 * UI display config for each ProcedureType.
 * Used by chips in the search dropdown and in order cards (v2 PRACTICES tab).
 */
export const PROCEDURE_TYPE_DISPLAY = {
  [ProcedureType.IMAGING]: {
    label: "Prácticas",
    sx: { bgcolor: "#6A1B9A", color: "#fff" },
  },
  [ProcedureType.LABORATORY]: {
    label: "Laboratorio",
    sx: { bgcolor: "#2E9E44", color: "#fff" },
  },
};
